export type STabSize = 'md' | 'lg';

export interface STabOption {
  label: string;
  value: string;
  badge?: string | number;
}

/** main(분절형) 사이즈별 레이아웃 — size는 높이·패딩만 바꾸고 폰트는 고정 */
export const TAB_MAIN_SIZE: Record<STabSize, { height: number; paddingX: number }> = {
  md: { height: 36, paddingX: 24 },
  lg: { height: 44, paddingX: 32 },
};

/** 탭 타이포 (main/sub 공통, token: typography.navigation.sm) */
export const TAB_TYPOGRAPHY = { fontSize: 12, lineHeight: 20 };

// 색상은 토큰(--cmp-tab-*) 참조 → token.json 변경이 전역 반영
export const TAB_MAIN_COLORS = {
  selected: {
    bg: 'var(--cmp-tab-main-selected-bg)',
    border: 'var(--cmp-tab-main-selected-border)',
    text: 'var(--cmp-tab-main-selected-text)',
  },
  default: {
    bg: 'var(--cmp-tab-main-default-bg)',
    border: 'var(--cmp-tab-main-default-border)',
    text: 'var(--cmp-tab-main-default-text)',
  },
};

export const TAB_SUB_COLORS = {
  selected: { text: 'var(--cmp-tab-sub-selected-text)', line: 'var(--cmp-tab-sub-selected-line)' },
  default: { text: 'var(--cmp-tab-sub-default-text)' },
};
